import * as React from 'react';
const SvgChevronRight = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M11.164 10 7.602 6.44a.55.55 0 0 1-.177-.384.53.53 0 0 1 .177-.39q.181-.182.388-.182.206 0 .393.189l3.864 3.863q.096.105.144.22a.6.6 0 0 1 .048.249.64.64 0 0 1-.192.46l-3.863 3.863q-.18.18-.38.174a.56.56 0 0 1-.38-.187.54.54 0 0 1-.182-.387q0-.207.181-.388z'
            />
        </g>
    </svg>
);
export default SvgChevronRight;
